enum ABCStatuses {
  'driver-preslot' = 1,
  'driver' = 2,
  'processing' = 3,
  'complete' = 4
}

export default ABCStatuses;



// WEBPACK FOOTER //
// ./src/enum/ABC-outbound-status.enum.ts